import React from 'react';
import { DNAChipProps } from '@alucio/lux-ui';
import { DNAChip } from 'src/components/DNA';
import { DocumentVersionORM } from 'src/types/orms';

interface DNADocumentVersionChipProps extends DNAChipProps {
  documentVersionORM: DocumentVersionORM;
}

/**
 * Beacon-specific DNAChip component for document version
 */
export const DNADocumentVersionChip: React.FC<DNADocumentVersionChipProps> = ({
  documentVersionORM,
  ...rest
}) => {
  const chipText = documentVersionORM.model.status === 'PUBLISHED'
    ? `V ${documentVersionORM.meta.version.semVerLabel}`
    : 'DRAFT IN PROGRESS';

  return (
    <DNAChip.Beacon
      testID="document-sem-ver-badge"
      children={chipText}
      {...rest}
    />
  );
};

export default DNADocumentVersionChip;
